module.exports = __webpack_public_path__ + "portal-static/img/txt.2df5d441.png";